// Defunct types that at one time were part of the protos barrel, and
// need to remain defined for backwards compatibility with older public-api
// versions.
// PostCollections: removed in DX-7031
// Can be removed when we're willing to break all 0.10.x and earlier apps.
export const PostCollectionsDefinition = {
    name: 'PostCollections',
    fullName: 'devvit.plugin.redditapi.postcollections.PostCollections',
    methods: {},
};
// RedditAPIV2: removed in DX-7031
// Can be removed when we're willing to break all 0.10.x and earlier apps.
export const RedditAPIV2Definition = {
    name: 'RedditAPIV2',
    fullName: 'devvit.plugin.redditapiv2.RedditAPIV2',
    methods: {},
};
// Can be removed when we're willing to break at least all @devvit/public-api
// v0.9.8 and v0.9.9 apps.
export const Empty = {
    $type: 'google.protobuf.Empty',
    fromPartial() {
        return {};
    },
};
// Found in some @devvit/public-api v0.9.8 and v0.9.9 apps.
export { OnSubredditSubscribeDefinition } from '../types/devvit/actor/automation/v1alpha/event_handlers.js';
export { InstanceSettingsDefinition } from '../types/devvit/actor/settings/v1alpha/instance_settings.js';
export { UserConfigurableDefinition } from '../types/devvit/actor/user_configurable/user_configurable.js';
export { Definition } from './Types.js';
// Found in
// wsbapp v0.0.1 (@devvit/public-api v0.10.10-next-2023-12-06-7020bea11.0) and
// v0.0.5.293 (@devvit/public-api v0.10.14, 2024-03-01).
export { ContextActionDefinition, ContextActionDescription, } from '../types/devvit/actor/reddit/context_action.js';
// Last present in @devvit/public-api v0.10.22, usage removed in
// https://github.snooguts.net/reddit/reddit-devplatform-monorepo/pull/6102
export const AssetResolverDefinition = {
    name: 'AssetResolver',
    fullName: 'devvit.plugin.assetresolver.AssetResolver',
    methods: {},
};
// Found in purge-user v0.0.1 (@devvit/public-api v0.9.8). unclear why this
// this version of @devvit/public-api v0.9.8 had extra dependencies.
export { ConfigFieldType, ConfigForm, } from '../types/devvit/actor/user_configurable/user_configurable.js';
// Removed before the 0.11.0 release.
export { BlockFullSnooSize } from '../types/devvit/ui/block_kit/v1beta/enums.js';
// Used by comment-nuke
export const ModlogDefinition = {
    name: 'Modlog',
    fullName: 'devvit.plugin.modlog.Modlog',
    methods: {},
};
